import React from "react";
import {
  Box,
  Container,
  Typography,
  Stack,
  Avatar,
} from "@mui/material";
import { motion } from "framer-motion";
import quote99Icon from "../../Assets/Icons/99 icon.svg";
import backgroundLeft from "../../Assets/Icons/Background-1.svg";
import backgroundRight from "../../Assets/Icons/Background -2.svg";

const testimonials = [
  {
    quote:
      "Abilio transformed our 4-bedroom shell into a masterpiece of modern design. Their attention to material selection and lighting was unlike any firm we've ever worked with. Truly structural elegance.",
    name: "Rajesh Malhotra",
    title: "Homeowner, South Mumbai",
    avatarBg: backgroundLeft,
  },
  {
    quote:
      "As a developer, reliability is everything. Abilio Infrastructure delivered our commercial complex ahead of schedule with structural integrity that exceeded our engineers' expectations.",
    name: "Ananya Deshpande",
    title: "CEO, Zenith Urban Developers",
    avatarBg: backgroundRight,
  },
];

const TestiMonialsSection = () => {
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1,
      },
    },
  };

  const titleVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 60, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.7,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        backgroundColor: "#F6F3F2",
        pt: { xs: "64px", sm: "96px", md: "128px" },
        pb: { xs: "64px", sm: "96px", md: "128px" },
        minHeight: { md: "653px" },
        boxSizing: "border-box",
      }}
    >
      <Container
        maxWidth={false}
        disableGutters
        sx={{
          maxWidth: "1280px",
          mx: "auto",
          px: { xs: "20px", sm: "24px", md: "32px" },
          minHeight: { md: "397px" },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: "48px", md: "80px" },
          boxSizing: "border-box",
        }}
      >
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={titleVariants}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "1216px",
              display: "flex",
              justifyContent: "center",
              minHeight: { md: "40px" },
            }}
          >
            <Typography
              component="h2"
              sx={{
                fontFamily: "Manrope",
                fontWeight: 800,
                fontSize: { xs: "28px", sm: "32px", md: "36px" },
                lineHeight: { xs: "36px", sm: "38px", md: "40px" },
                letterSpacing: { xs: "-1.4px", md: "-1.8px" },
                textAlign: "center",
                color: "#1C1917",
                maxWidth: "100%",
              }}
            >
              Voices of Excellence
            </Typography>
          </Box>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={containerVariants}
        >
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={0}
            sx={{
              width: "100%",
              maxWidth: "1216px",
              gap: { xs: "32px", md: "48px" },
              justifyContent: "flex-start",
              alignItems: { xs: "stretch", md: "flex-start" },
            }}
          >
            {testimonials.map((item, index) => (
              <motion.div
                key={item.name}
                variants={cardVariants}
                whileHover={{
                  y: -8,
                  scale: 1.01,
                  transition: { duration: 0.3, ease: "easeOut" },
                }}
                style={{ width: "100%" }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: { xs: "100%", md: "584px" },
                    maxWidth: "100%",
                    minHeight: { md: "277px" },
                    flexShrink: 0,
                    backgroundColor: "#FFFFFF",
                    borderRadius: "16px",
                    p: { xs: "28px", sm: "32px", md: "40px" },
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    textAlign: "left",
                    overflow: "hidden",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.04)",
                    transition: "box-shadow 0.3s ease",
                    "&:hover": {
                      boxShadow: "0px 16px 40px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={quote99Icon}
                    alt=""
                    aria-hidden
                    sx={{
                      position: "absolute",
                      top: { xs: "12px", md: "16px" },
                      right: { xs: "16px", md: "24px" },
                      width: { xs: "36px", md: "44px" },
                      height: "auto",
                      pointerEvents: "none",
                      userSelect: "none",
                      transition: "transform 0.3s ease",
                    }}
                  />

                  <Typography
                    sx={{
                      position: "relative",
                      zIndex: 1,
                      width: "100%",
                      fontFamily: "Inter",
                      fontWeight: 400,
                      fontSize: { xs: "15px", md: "16px" },
                      lineHeight: { xs: "24px", md: "26px" },
                      fontStyle: "italic",
                      color: "#44403C",
                      textAlign: "left",
                      pr: { xs: "28px", md: "36px" },
                      mb: { xs: "24px", md: "32px" },
                      flex: 1,
                    }}
                  >
                    {item.quote}&rdquo;
                  </Typography>

                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="flex-start"
                    sx={{
                      position: "relative",
                      zIndex: 1,
                      mt: "auto",
                      width: "100%",
                      textAlign: "left",
                    }}
                  >
                    <Avatar
                      src={item.avatarBg}
                      alt={item.name}
                      variant="rounded"
                      sx={{
                        width: 52,
                        height: 52,
                        borderRadius: "8px",
                        bgcolor: "#E7E5E4",
                        transition: "transform 0.3s ease",
                        "&:hover": {
                          transform: "scale(1.05)",
                        },
                      }}
                    />
                    <Box sx={{ minWidth: 0, textAlign: "left" }}>
                      <Typography
                        sx={{
                          fontFamily: "Manrope",
                          fontWeight: 700,
                          fontSize: "16px",
                          lineHeight: "22px",
                          color: "#1C1917",
                          textAlign: "left",
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: 400,
                          fontSize: "14px",
                          lineHeight: "20px",
                          color: "#78716C",
                          mt: "2px",
                          textAlign: "left",
                        }}
                      >
                        {item.title}
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              </motion.div>
            ))}
          </Stack>
        </motion.div>
      </Container>
    </Box>
  );
};

export default TestiMonialsSection;
